import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'lib-checkbox-formly',
  templateUrl: './checkbox.component.html'
})
export class CheckboxTypeComponent extends FieldType {
}
